import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocale } from '~/i18n';
import { bubbleConfig, bubblePlacement, loadWhatsappButton, removeBubble } from '~/lib/jobsWhatsapp';

/**
 * La burbuja de WhatsApp de TBit Jobs, abajo a la derecha (`lib/jobsWhatsapp.ts`
 * decide dónde va y con qué primer mensaje). No pinta nada propio: el botón lo
 * dibuja el script de TBit. Se rearma solo cuando cambia para quién es o el
 * idioma, no en cada navegación: así no se cierra el panel si alguien lo abrió.
 */
export default function JobsWhatsappBubble() {
  const { pathname } = useLocation();
  const appLocale = useLocale();
  const placement = bubblePlacement(pathname);
  const audience = placement?.audience ?? null;
  const locale = placement?.locale ?? appLocale;
  const compact = placement?.compact ?? false;

  useEffect(() => {
    if (!audience) {
      removeBubble();
      return;
    }
    let cancelled = false;
    loadWhatsappButton()
      .then((start) => {
        if (!cancelled) start(bubbleConfig(audience, locale, compact));
      })
      // Sin la burbuja la app sigue igual: es un atajo, no un camino obligado.
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [audience, locale, compact]);

  useEffect(() => () => removeBubble(), []);

  return null;
}
